let galleryDeleteBtn = null;
$(function() {
    let gallerySubmitBtn = $('#btnSubmitGallery');
    galleryDeleteBtn = $('#btnDeleteGallery');
    var dz = $("#galleryDropzonejs").dropzone({
        maxFiles: 50,
        maxFilesize: 15,
        uploadMultiple: true,
        parallelUploads: 2,
        createImageThumbnails: true,
        url: '/gallery/store',
        autoProcessQueue: false,
        acceptedFiles: '.jpg, .jpeg .png .gif',
        addRemoveLinks: true,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        // Language Strings
        dictRemoveFile: Lang.get('messages.delete'),
        dictFileTooBig: "File is to big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
        dictInvalidFileType: "Invalid File Type",
        dictCancelUpload: "Cancel",
        dictMaxFilesExceeded: "Only {{maxFiles}} files are allowed",
        dictDefaultMessage: "Drop files here to upload",
        successmultiple: function(data,response){
            if (response.success) {
                if(dz[0].dropzone.getQueuedFiles().length > 0){
                    dz[0].dropzone.processQueue();
                }else{
                    window.setTimeout(function(){
                        $.toast({
                            text: Lang.get('messages.good_job'),
                            icon: 'success',
                            position: 'bottom-right'
                        });
                        $('#wp').trigger('change');
                    }, 500);
                }
            } else {
                $.toast({
                    text: Lang.get('messages.unable_to_upload'),
                    icon: 'warning',
                    position: 'bottom-right'
                });
                gallerySubmitBtn.removeAttr('disabled');
            }
        },
        init: function () {
            this.on("sending", function (file, xhr, formData) {
                $('#formGalleryUpload').find('input, textarea, select').each(function () {
                    formData.append($(this).attr('name'), $(this).val());
                });
            });

            this.on("maxfilesexceeded", function (file) {
                this.removeAllFiles();
                this.addFile(file);
            });

            this.on("addedfile", function (file, xhr, formData) {
                // Aquí puedes reordenar la cola antes de procesarla.
                this.files.sort(function(a, b) {
                    return b.name.localeCompare(a.name);
                });
                if (this.files.length > 0) {
                    gallerySubmitBtn.removeAttr('disabled');
                }
            });
            this.on("removedfile", function (file) {
                if (this.files.length === 0) {
                    gallerySubmitBtn.attr('disabled', 'disabled');
                }
            })
        },
        errormultiple: function (file, errorMessage, xhr) {
            $.toast({
                text: errorMessage,
                icon: 'warning',
                position: 'bottom-right',
                allowToastClose: true,
                hideAfter: 60000,
            });
            gallerySubmitBtn.removeAttr('disabled');
        }
    });

    $('#formGalleryUpload').submit(function(e){
        e.preventDefault();

        //Processo la cua
        if(dz[0].dropzone.getQueuedFiles().length > 0){
            e.preventDefault();
            dz[0].dropzone.processQueue();
        }

        if(dz[0].dropzone.files.length < 1){
            gallerySubmitBtn.removeAttr('disabled');
            $.toast({
                text : Lang.get('messages.attach_your_file_first'),
                icon: 'warning',
                position : 'bottom-right'
            });
        }else{
            gallerySubmitBtn.attr('disabled', true);
        }
        return false;
    });

    $('#tableGallery')
        .on("change", 'input[name="checkAll"]', function(){
            $('#tableGallery > tbody').find('input[type="checkbox"]').prop('checked', $(this).is(':checked'));
            galleryItemsChecked();
        })
        .on("change", 'tbody input.custom-control-input', function(){
            galleryItemsChecked();
        });

    galleryDeleteBtn.click(function(){
        let arr = [];
        $('#tableGallery').find('tbody input[type="checkbox"]:checked').each(function(){
            arr.push($(this).val());
        });
        if(arr.length > 0){
            Swal.fire({
                title: 'Segur que vols eliminar les fotos?',
                text: "Aquesta acció donarà de baixa "+arr.length+" fotos.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, elimina'
            }).then((result) => {
                if (result.isConfirmed) {
                    $.post("/ajax/gallery/destroy", {items: arr, page: getPageParameter()}, function (json) {
                        if(json.success === true){
                            $.toast({
                                text: arr.length+' fotos eliminades correctament',
                                icon: 'success',
                                duration: 2000,
                                position: 'bottom-right'
                            });
                            window.setTimeout(function(){
                                window.location.href = '/gallery?page='+json.page;
                            }, 2000)
                        }
                    }, 'json');
                }
            });
        }
    });
});

function galleryItemsChecked()
{
    let numChecked = $('#tableGallery > tbody').find('input[type="checkbox"]:checked').length;
    galleryDeleteBtn.attr('disabled', numChecked === 0 ? 'disabled' : null);
}

function getPageParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('page');
}

